import GenerateQuestion from "../GenereteQuestion/GeneratQuestion";
import ToggleButton from "../ToggleButton/ToggleButton";
import FormConjuge from "./FormCojunge/FormConjuge";
import "./FormSecondary.css";
import { Col, Container, Row } from "react-bootstrap";

const FormSecondary = () => {

  return (
    <Container className="custom-margin-left mt-3 p-0 mb-2" fluid>
      <Row className="d-flex align-items-start">
      <Col
          xs={12}
          lg={3}
          className="d-flex justify-content-center align-items-center p-0 px-4 px-md-0"
        >
          <GenerateQuestion
            className="column-25"
            header="Cônjuge vai participar da renda?"
            subheader="Cônjuge é o indivíduo que está em uma relação conjugal, casado oficialmente."
          />
        </Col>
        <Col xs={1} sm={1} md={1} lg={1}></Col>
        <Col className="me-xl-5 mx-2 ">
          <ToggleButton
            id="2"
            textOn="Adicionar um cônjuge"
            textOff="Adicionar um cônjuge"
          >
            <FormConjuge name1="Cônjuge" />
          </ToggleButton>
        </Col>
      </Row>
    </Container>
  );
};

export default FormSecondary;
